import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { GetGameScoresQuery } from "@/graphql/gql/graphql";
import { getGameScores } from "../api";

const useGameScores = (
  gameId: number,
  queryOptions: Partial<UseQueryOptions<GetGameScoresQuery>> = {}
) => {
  const { data, isLoading, isError } = useQuery({
    ...queryOptions,
    queryKey: ["getGameScores", gameId],
    queryFn: () => getGameScores(gameId),
  });

  return {
    data,
    isLoading,
    isError,
  };
};

export default useGameScores;
